import {useState, useEffect} from 'react';

const useCarousel = (data, threshold) => {
  const [leftCursor, setLeftCursor] = useState(0);
  const [rightCursor, setRightCursor] = useState(threshold);

  const isAllowed = index => index < rightCursor && index >= leftCursor;
  const [dataList, setDataList] = useState(data.filter((_, index) => isAllowed(index)));

  const isLeftCursorActive = leftCursor > 0;
  const isRightCursorActive = rightCursor <= data.length - 1;

  const increment = () => {
    if (!isRightCursorActive || rightCursor === data.length) {
      return;
    }
    setLeftCursor(leftCursor => leftCursor + 1);
    setRightCursor(rightCursor => rightCursor + 1);
  };

  const decrement = () => {
    if (!isLeftCursorActive || leftCursor === 0 || rightCursor === threshold - 1) {
      return;
    }
    setLeftCursor(leftCursor => leftCursor - 1);
    setRightCursor(rightCursor => rightCursor - 1);
  };

  useEffect(() => {
    setDataList(data.filter((_, index) => isAllowed(index)));
  }, [leftCursor, rightCursor]);

  useEffect(() => {
    setDataList(data.filter((_, index) => isAllowed(index)));
    setLeftCursor(0);
    setRightCursor(threshold);
  }, [data]);

  return {
    dataList,
    increment,
    decrement,
    leftCursor,
    rightCursor,
    isLeftCursorActive,
    isRightCursorActive,
  };
};

export default useCarousel;
